// extracted by mini-css-extract-plugin
module.exports = {"gradient":"AnnouncementBanner_gradient__VpQSH","highlight":"AnnouncementBanner_highlight__mIPfC","gradientRapid":"AnnouncementBanner_gradientRapid__Jm8df"};